module.exports = __webpack_public_path__ + "img/CCD_LOGO_2.818d89d8.png";